<template>
  <md-dialog
    v-bind="$attrs"
    v-on="$listeners"
    :md-fullscreen="true"
    :md-close-on-esc="true"
    :md-click-outside-to-close="false"
    @md-opened="onModalOpened"
  >
    <md-dialog-title>Position Picture</md-dialog-title>

    <slot>
      <vue-cropper
        class="my-vue-cropper"
        ref="cropper"
        :src="src"
        :aspectRatio="1 / 1"
      >
      </vue-cropper>
    </slot>

    <md-dialog-actions>
      <md-button @click="onCancel">{{ cancelText }}</md-button>
      <md-button class="md-primary" @click="onConfirm">
        <span v-if="loading">
          <md-progress-spinner :md-diameter="30" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner>
        </span>
        <span v-else>
          {{ confirmText }}
        </span>
      </md-button>
    </md-dialog-actions>
  </md-dialog>
</template>

<script>
import VueCropper from 'vue-cropperjs'
export default {
  name: 'Cropper',
  components: {
    VueCropper
  },
  props: {
    src: {
      type: String,
      required: true
    },
    confirmText: {
      type: String,
      default: 'Ok'
    },
    cancelText: {
      type: String,
      default: 'Cancel'
    }
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    cropper () {
      return this.$refs.cropper
    }
  },
  methods: {
    onModalOpened () {
      this.loading = false
      this.cropper.replace(this.src)
      this.cropper.$forceUpdate()
    },
    onCancel () {
      this.$emit('md-cancel')
      this.$emit('update:mdActive', false)
    },
    onConfirm () {
      this.loading = true
      console.log(this.cropper)
      this.cropper.getCroppedCanvas().toBlob((blob) => {
        this.$emit('image-cropped', blob)
      }, 'image/jpeg', 1.0)
    }
  }
}
</script>

<style lang="scss">
  @import '../assets/theme.scss';
  .my-vue-cropper {
    margin-top: 5px;
    margin-bottom: 5px;
    max-height: calc(80vh - 130px);
  }
  .cropper-point,
  .cropper-line {
    background-color: $primary;
  }
</style>



// WEBPACK FOOTER //
// src/components/Cropper.vue